import React, { useEffect, useState } from 'react';
import styles from "../MetaField.module.scss";
import { CustomDropdown } from 'components/shared/customDropdown';
import { TextField } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from '@redux/slices/triggerSlice';
import { setPublish } from '@redux/slices/globalSlice';

const options = [
    { label: "greater than or equal", value: "greater than or equal" },
    { label: "less than or equal", value: "less than or equal" },
    { label: "is between", value: "is between" },
    { label: "is not between", value: "is not between" }
];

const TimeToComplete = ({ item }) => {
    const [localOptions, setLocalOptions] = useState({
        label: "Time To Complete",
        options: item?.trigger?.options || "is between",
        value: []
    });

    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const dispatch = useDispatch();

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            const updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                if (value === "is between" || value === "is not between") {
                    return { ...updatedOptions, value: ["", ""] };
                }
                return { ...updatedOptions, value: [""] };
            }

            if (name === "time1" || name === "time2") {
                const [time1, time2] = name === "time1" ? [value, prev.value[1]] : [prev.value[0], value];
                return { ...updatedOptions, value: [time1, time2] };
            }

            if (name === "value") {
                return { ...updatedOptions, value: [value] };
            }

            return updatedOptions;
        });
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) =>
            e?.id === item?.id
                ? {
                    ...e,
                    optionLabel: item?.label || "Time To Complete",
                    trigger: { ...localOptions }
                }
                : e
        );
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            value: item?.value || prev?.value
        }));
    }, [item?.operator, item?.value]);

    const renderTimeInputs = () => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <InputMask
                mask="99:99:99"
                value={localOptions?.value[0]}
                onChange={(e) => handleChange("time1", e.target.value)}
                maskChar="0"
            >
                {(inputProps) => <TextField {...inputProps} placeholder="00:00:00" />}
            </InputMask>
            <span style={{ fontWeight: "700", fontSize: "15px" }}>Between</span>
            <InputMask
                mask="99:99:99"
                value={localOptions?.value[1]}
                onChange={(e) => handleChange("time2", e.target.value)}
                maskChar="0"
            >
                {(inputProps) => <TextField {...inputProps} placeholder="00:00:00" />}
            </InputMask>
        </div>
    );

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value="Time To Complete" disabled />
                <CustomDropdown
                    options={options}
                    value={localOptions?.options}
                    width="200px"
                    onChange={(e) => handleChange("options", e.target.value)}
                    name="options"
                />
                {localOptions?.options === "is between" || localOptions?.options === "is not between"
                    ? renderTimeInputs()
                    : (
                        <InputMask
                            mask="99:99:99"
                            value={localOptions?.value[0] || ""}
                            onChange={(e) => handleChange("value", e.target.value)}
                            maskChar="0"
                        >
                            {(inputProps) => <TextField {...inputProps} placeholder="00:00:00" />}
                        </InputMask>
                    )}
            </div>
            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default TimeToComplete;
